import React, { useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import PrintIcon from '@mui/icons-material/Print';
import { QRCodeCanvas } from 'qrcode.react';
import { buildTableQrUrl, downloadCanvasAsPng, openPrintWindow } from '../../utils/qrUtils';

interface QRCodeModalProps {
  open: boolean;
  onClose: () => void;
  storeId: string;
  table: { id: string; name: string };
}

/**
 * 1テーブル分の sitting URL の QR を表示し、PNGダウンロード・印刷を行うモーダル。
 */
const QRCodeModal: React.FC<QRCodeModalProps> = ({ open, onClose, storeId, table }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const url = buildTableQrUrl(storeId, table.id);

  const handleDownload = () => {
    if (canvasRef.current) {
      downloadCanvasAsPng(canvasRef.current, table.name);
    }
  };

  const handlePrint = () => {
    if (canvasRef.current) {
      openPrintWindow([{ name: table.name, dataUrl: canvasRef.current.toDataURL('image/png') }]);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="qr-code-dialog"
      PaperProps={{ sx: { minWidth: '390px' } }}
    >
      <DialogTitle id="qr-code-dialog">{table.name} のQRコード</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 1 }}>
          <QRCodeCanvas ref={canvasRef} value={url} size={240} marginSize={2} level="M" />
          <Typography
            variant="body2"
            sx={{ wordBreak: 'break-all', textAlign: 'center', color: 'text.secondary' }}
          >
            {url}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1, flexWrap: 'wrap', justifyContent: 'space-between' }}>
        <Button
          sx={{ flex: 1 }}
          onClick={handleDownload}
          color="primary"
          variant="contained"
          startIcon={<DownloadIcon />}
        >
          ダウンロード
        </Button>
        <Button
          sx={{ flex: 1 }}
          onClick={handlePrint}
          color="primary"
          variant="contained"
          startIcon={<PrintIcon />}
        >
          印刷
        </Button>
        <Button sx={{ flexBasis: '100%' }} onClick={onClose} color="error" variant="contained">
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QRCodeModal;
